import React from 'react';
import styled from 'styled-components';
import { MaterialIcon } from '@pearsontechnology/aero-components';

const IconRemoveWrapper = styled.span`
  display: inline-flex;
  margin-right: 7px;
  margin-left: -4px;
`;

const IconRemove = () => (
  <IconRemoveWrapper>
    <MaterialIcon id={'delete'} />
  </IconRemoveWrapper>
);

export {
  IconRemove,
};
